module.exports = __webpack_public_path__ + "img/avtoaksessuary.c8d6845b.svg";